export const PRODUCT_MODULE_NAME = "sản phẩm";
export const PRODUCT_MODULE_URL = "/sales/product";
